module.exports = __webpack_public_path__ + "odinstatic/v17.0.0/media/operator-info.c1ef1241.svg";